import { InternationalRemittanceList } from "../../views/amount/InternationalRemittanceList";
import { InternationalRemittanceCountriesList } from "../../views/amount/InternationalRemittanceCountriesList";
import { InternationalRemittanceChannelList } from "../../views/amount/InternationalRemittanceChannelList";
import { InternationalRemittanceCreditedTimesList } from "../../views/amount/InternationalRemittanceCreditedTimesList";
import { InternationalRemittanceLimitList } from "../../views/amount/InternationalRemittanceLimitList";
import { InternationalRemittanceSlippageList } from "../../views/amount/InternationalRemittanceSlippageList";
import { InternationalRemittanceCurrencyConversionList } from "../../views/amount/InternationalRemittanceCurrencyConversionList";
import { PayChannelList } from "../../views/globalPay/PayChannelList";
import { PayCurrencyList } from "../../views/globalPay/PayCurrencyList";
import { PayConfigList } from "../../views/globalPay/PayConfigList";
import { PayOrderList } from "../../views/globalPay/PayOrderList";

const globalPayName = "全球付";
const scanPayName = "扫码支付管理";

export const globalPayRouters = [
    {
        path: "/globalPay/internationalRemittanceList",
        name: "internationalRemittanceList",
        exact: true,
        component: InternationalRemittanceList,
        meta: {
            breadcrumb: [
                { name: globalPayName, path: "" },
                { name: "国际汇款列表", path: "" }
            ],
            privilegeCode: "internationalRemittanceList",
        }
    },
    {
        path: "/globalPay/internationalRemittanceCountriesList",
        name: "internationalRemittanceCountriesList",
        exact: true,
        component: InternationalRemittanceCountriesList,
        meta: {
            breadcrumb: [
                { name: globalPayName, path: "" },
                { name: "国际汇款国家列表", path: "" }
            ],
            privilegeCode: "internationalRemittanceCountriesList",
        }
    },
    {
        path: "/globalPay/internationalRemittanceChannelList",
        name: "internationalRemittanceChannelList",
        exact: true,
        component: InternationalRemittanceChannelList,
        meta: {
            breadcrumb: [
                { name: globalPayName, path: "" },
                { name: "国际汇款通道列表", path: "" }
            ],
            privilegeCode: "internationalRemittanceChannelList",
        }
    },
    {
        path: "/globalPay/internationalRemittanceCreditedTimesList",
        name: "internationalRemittanceCreditedTimesList",
        exact: true,
        component: InternationalRemittanceCreditedTimesList,
        meta: {
            breadcrumb: [
                { name: globalPayName, path: "" },
                { name: "国际汇款通道时效列表", path: "" }
            ],
            privilegeCode: "internationalRemittanceCreditedTimesList",
        }
    },
    {
        path: "/globalPay/internationalRemittanceLimitList",
        name: "internationalRemittanceLimitList",
        exact: true,
        component: InternationalRemittanceLimitList,
        meta: {
            breadcrumb: [
                { name: globalPayName, path: "" },
                { name: "国际汇款限额列表", path: "" }
            ],
            privilegeCode: "internationalRemittanceLimitList",
        }
    },
    {
        path: "/globalPay/internationalRemittanceSlippageList",
        name: "internationalRemittanceSlippageList",
        exact: true,
        component: InternationalRemittanceSlippageList,
        meta: {
            breadcrumb: [
                { name: globalPayName, path: "" },
                { name: "国际汇款滑点列表", path: "" }
            ],
            privilegeCode: "internationalRemittanceSlippageList",
        }
    },
    {
        path: "/globalPay/internationalRemittanceCurrencyConversionList",
        name: "internationalRemittanceCurrencyConversionList",
        exact: true,
        component: InternationalRemittanceCurrencyConversionList,
        meta: {
            breadcrumb: [
                { name: globalPayName, path: "" },
                { name: "国际汇款货币转换列表", path: "" }
            ],
            privilegeCode: "internationalRemittanceCurrencyConversionList",
        }
    },
    {
        path: "/globalPay/scanPay/payChannelList",
        name: "payChannelList",
        exact: true,
        component: PayChannelList,
        meta: {
            breadcrumb: [
                { name: globalPayName, path: "" },
                { name: scanPayName, path: "" },
                { name: "消费支付通道列表", path: "" }
            ],
            privilegeCode: "payChannelList",
        }
    },
    {
        path: "/globalPay/scanPay/payCurrencyList",
        name: "payCurrencyList",
        exact: true,
        component: PayCurrencyList,
        meta: {
            breadcrumb: [
                { name: globalPayName, path: "" },
                { name: scanPayName, path: "" },
                { name: "消费支付币种列表", path: "" }
            ],
            privilegeCode: "payCurrencyList",
        }
    },
    {
        path: "/globalPay/scanPay/payConfigList",
        name: "payConfigList",
        exact: true,
        component: PayConfigList,
        meta: {
            breadcrumb: [
                { name: globalPayName, path: "" },
                { name: scanPayName, path: "" },
                { name: "消费支付配置列表", path: "" }
            ],
            privilegeCode: "payConfigList",
        }
    },
    {
        path: "/globalPay/scanPay/payOrderList",
        name: "payOrderList",
        exact: true,
        component: PayOrderList,
        meta: {
            breadcrumb: [
                { name: globalPayName, path: "" },
                { name: scanPayName, path: "" },
                { name: "支付订单列表", path: "" }
            ],
            privilegeCode: "payOrderList",
        }
    },
];
